import { useState, useEffect } from "react";
import { MOOD_OPTIONS as DEFAULT_MOOD_OPTIONS } from "@/frontend";

export type MoodOption = {
  label: string;
  color: string;
};

export function useMoodOptions() {
  const [moodOptions, setMoodOptions] = useState<MoodOption[]>(() => {
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem("moodboard-options");
      if (saved) {
        try {
          return JSON.parse(saved);
        } catch (e) {
          console.error("Failed to parse mood options", e);
        }
      }
    }
    return DEFAULT_MOOD_OPTIONS as MoodOption[];
  });

  useEffect(() => {
    localStorage.setItem("moodboard-options", JSON.stringify(moodOptions));
  }, [moodOptions]);

  const updateMoodLabel = (index: number, newLabel: string) => {
      const newOptions = [...moodOptions];
      if (newOptions[index]) {
          newOptions[index] = { ...newOptions[index], label: newLabel };
          setMoodOptions(newOptions);
      }
  };

  const resetToDefaults = () => {
      setMoodOptions(DEFAULT_MOOD_OPTIONS);
  };

  return { moodOptions, updateMoodLabel, resetToDefaults };
}
